
import React, { useState, useRef, useEffect , useContext  } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import ProgressBar from 'react-bootstrap/ProgressBar';
import { ToastContainer, toast, Zoom } from 'react-toastify';
import {customalert , getUser ,  updateSession, filebasepath, loaderBar, errorToast, successToast, apibaseURl, changeDateFotmate, loggedInCustomerDetails } from '../../functions/Function';
import  { WebContext }  from "../../Webroute";
import Howtouploadselfie  from './Howtouploadselfie';
const Kyc = (props) => {
   const WebData = useContext(WebContext);
   const [selfiemodalShow, setselfiemodalShow] = React.useState(false);
   const [isloading, setisloading] = useState(true);
   const [disabled, setDisabled] = useState(false);
   const [uploadloader, setuploadloader] = useState(false);
   const [kycview, setKycview] = useState(true);
   const [uploadselfie, setuploadselfie] = useState(true);
   const [selfiePreview, setselfiePreview] = useState('');
   const [user, setUser] = useState(false);
   const [paymentOptions, setpaymentOptions] = useState({});
   const [image, setimage] = useState('');
   const aRef = useRef(null);

   const [progress, setProgress] = useState(false);
   const [progresscount, setProgresscount] = useState(0);
   const [variant, setVariant] = useState('danger');
   const [doctype, setdoctype] = useState('ADDHAR CARD');
   const [idnumber, setIdnumber] = useState('');
   const timer = () => {
      setTimeout(() => {
         setisloading(false);
      }, 1000);
   }

   const handleClick = () => {
      aRef.current.click();
   };
   
   const uploadImage = (event) => {
      setuploadloader(true);
      var files = event.target.files[0];
      
      setimage(files);
      
      let reader = new FileReader();
      reader.readAsDataURL(files);
      reader.onload = function () {
         console.log(reader.result);
         setselfiePreview(reader.result)
     }
      
       console.log(files);
       //console.log(url);
     

      aRef.current.value  = '';
      setuploadloader(false);
   }

   const changeHandler = (event) => {
      const formData = new FormData();
      var file = image;
      if(idnumber == '')
      {
         errorToast('Please enter id number', 'bottom-right', 3000, true);
         return false;
      }
      if (file == '') {
         errorToast('Please upload selfie', 'bottom-right', 3000, true);
         return false;
      }
      
      const config = {
         onUploadProgress: function (progressEvent) {
            setProgress(true);
            setVariant('danger');
            var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
            setProgresscount(percentCompleted);
            setuploadloader(true)
         }
      }
      let data = new FormData()
      data.append('image', file)
      data.append('user_id', loggedInCustomerDetails('id'))
      data.append('doctype', doctype)
      data.append('id_number', idnumber)
      axios.post(apibaseURl + "uploadSelfie", data, config)
         .then(function (res) {

            if (res.status == 200) {
               
               WebData.updateUser();
               if (res.data.result == true) {
                  userdata();
                  setVariant('success');
                  setProgress(false);
                  setselfiePreview(filebasepath() + res.data.response.image);
                  successToast('Selfie uploaded successfully', 'bottom-right', 3000, true);
               } else if (res.data.validation == true) {
                  errorToast(res.data.response.image, 'bottom-right', 3000, true);
               }
               else {
                  errorToast(res.data.response, 'bottom-right', 3000, true);
               }

               setTimeout(() => {
                  setuploadloader(false);
               }, 1000);

            }
         }
         )
         .catch(err => console.log(err))
   };


   const userdata = async () =>
   {
      var result =   await getUser();
      if(result.status == true)
      {
         setUser(result.response);
         updateSession('is_approved', result.response.is_approved)
         if (result.response.selfi_info.image) {
            setselfiePreview(filebasepath() + result.response.selfi_info.image);
         }
         timer()
      }
   
   }

   const getPaymentOptions = async () =>
   {
      var getpaymentOptionsList = await  axios({
         method: "GET",
         url: apibaseURl+"getPaymentOptions"
      });
      var result = getpaymentOptionsList.data;
      if(result.status == true)
      {
         setpaymentOptions(result.response);
      }
   }
   useEffect(() => {
      getPaymentOptions();
      userdata();
   }, [])
   
   const KycSteperAndGreetings = ({ user }) => {
      return (
    
      <div className="congrass-box">
            <div className="chek-process-box">
               <div className="process-box text-center">
                  {user.is_email_verify == "1" ? (
                     <i className="fa-solid fa-check kycICon kycIConGreenIcon"></i>
                  ) : (
                     <i className="fa-solid fa-xmark kycICon kycIConRedIcon"></i>
                  )}

                  <div className="process-box-h">EMAIL</div>
               </div>
               <div className="process-box text-center">
                  {user.selfi_info.status == "accepted" ? (
                     <i className="fa-solid fa-check kycICon kycIConGreenIcon"></i>
                  ) : (
                     <i className="fa-solid fa-xmark kycICon kycIConRedIcon"></i>
                  )}

                  <div className="process-box-h">Selfie</div>
               </div>
               <div className="process-box text-center">
                  {user.is_approved == "1" ? (
                     <>
                        <i className="fa-solid fa-check kycICon kycIConGreenIcon"></i>
                        <div className="process-box-h">Approved</div>
                     </>
                  ) : (
                     <>
                        <i className="fa-solid fa-xmark kycICon kycIConRedIcon"></i>
                        <div className="process-box-h">Approved </div>
                     </>
                  )}
               </div>
            </div>

               {user.is_approved == '1' ?           
                  <div className="footer-check-process text-center">
                     <div>
                        <h3>Congratulations!</h3>
                        <p className="text-success mt-3"><b>Your Ivoire account is approved.</b></p>
                     </div>
                     <div>
                        <Link to="/home" className="btn ivo-site-btn ivo-site-btn-v-2">Start Trading</Link>
                     </div>
                  </div>
               
            : 
               <>
                  {user.selfi_info.status == 'accepted' &&            
                  <div className="footer-check-process text-center">
                        <div>
                           <h6>Congratulations! Your KYC is completed.</h6>
                           <p className="text-success mt-3"><b>After verifying your account will be approved.</b></p>
                        </div>
                     </div>
                  }
               </>
            }


               

               

               {user.selfi_info.status == 'uploaded' &&            
                  <div className="footer-check-process text-center">
                     <div>
                        <h6>Congratulations! Your selfie has been successfully uploaded</h6>
                        <p className="text-success mt-3"><b>After verifying your selfie image will be approved.</b></p>
                     </div>
                  </div>
               }
      </div>

     

      )
   }

   return (
      <> 
         <Howtouploadselfie show={selfiemodalShow}
                onHide={() => setselfiemodalShow(false)}  />
         <ToastContainer />
         <div className="account-right-content-shdow">
         {user.selfi_info?.status == 'rejected' &&
               customalert('Selfie uploaded for KYC has been rejected after verification, upload it again.' , 'info')
         }
         {user.selfi_info?.note != '' && user.selfi_info?.status == 'rejected' &&
               customalert('Reason : ' + user.selfi_info?.note , 'info')
         }

         
            <h5 className="account-tab-heading">
               Verify KYC
            </h5>
            
            {isloading == true && loaderBar(200, 25)}
            {isloading == false &&
               <>
                  <KycSteperAndGreetings user={user}  />
                 
                  {(user.selfi_info.status == 'rejected'  || user.selfi_info.status == '' ) ?
                     <>
                        <div className="row">
                           <div className=" text-center col-sm-12 mt-4 mb-2" >
                                 <button className="howtoUploadselfiebtn" onClick={() => setselfiemodalShow(true)} >How To Upload Selfie</button>
                           </div>
                           <div className="col-sm-12 mb-2">
                              <div className="form-group">
                                 <label>Select Document</label>  
                                 {paymentOptions.length > 0 && 
                                 <select   onChange={(e) => setdoctype(e.target.value)}  className="form-control" name="" defaultValue={paymentOptions['0'] || 'Select'}>
                                   
                                    {paymentOptions.length > 0 ? paymentOptions.map((option, i) => (
                                    <option value={option}>{option}</option>
                                    )) : ''}
                                    
                                 </select>  
                              }                   
                              </div>
                              <div className="form-group">
                                 <label>ID Number</label>
                                 <input
                                 type="text"
                                 className="form-control my-form-control"
                                 placeholder="XXXX XXXX XXX XXXX"
                                 value={idnumber}
                                 onChange={(e) => setIdnumber(e.target.value)}
                                 />
                                 </div>
                              <div className="form-group">
                                 <label>Upload Selfie</label>
                                       <section className="bg-diffrent"  >
                                          <div className="">
                                             {uploadloader == false &&
                                                <>
                                                   {selfiePreview != '' ?
                                                      <div className="text-center mt-3">
                                                         <img src={selfiePreview} width={'20%'} />
                                                      </div>
                                                   : <div><i className="fas fa-images"></i></div>} </>
                                                   }

                                                   { uploadloader == true &&
                                                      loaderBar(30, 25)
                                                   }
                                                   <div className="instence">Browse .jpg, .jpeg, .png</div>
                                                   <div>
                                                      <input
                                                         style={{ display: 'none' }}
                                                         ref={aRef}
                                                         type="file"
                                                         onChange={uploadImage}
                                                         accept="image/png, image/gif, image/jpeg"
                                                         capture
                                                      />
                                                      <button onClick={() => handleClick()} >Upload Selfie</button>
                                                   </div>

                                                   {user.selfi_info.status == 'uploaded' &&
                                                      <p className="text-danger"><b>Selfie image sent to admin for approval</b></p>
                                                   }

                                                   
                                          </div>
                                       </section>
                              </div>
                                <div className="text-center">
                                <button
                                       className="btn ivo-site-btn inline-btn"
                                       type="submit"
                                       disabled={disabled}
                                       onClick={changeHandler}
                                    >  {disabled == false ? "Submit" : "Submiting..."}
                                    </button>     
                                 </div>                   
                           </div>
                        </div>
                     </>
                  : ''}

               </>
            }
         </div>
      </>
   );
}

export default Kyc;
